import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { KarshnasMasol_Interface } from 'src/app/Interface/KarshnasMasol_Interface';
import { LetterRequestCustomer_Activity } from 'src/app/Interface/LetterRequestCustomer_Activity';
import { Empty_LetterRequestCustomer_Device_Interface, LetterRequestCustomer_Device_Interface } from 'src/app/Interface/LetterRequestCustomer_Device_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-LetterRequestCustomerMissionActivityList',
  templateUrl: './LetterRequestCustomerMissionActivityList.component.html',
  styleUrls: ['./LetterRequestCustomerMissionActivityList.component.scss']
})
export class LetterRequestCustomerMissionActivityListComponent implements OnInit {

  @Input() inner_Letter_id: number = 0
  @Input() inner_Customer_id: number = 0
  Token: String = ""
  InProccessing: boolean = false

  DataList_KarshnasMasol: Array<KarshnasMasol_Interface> = []
  DataList_KarshnasMasol_link: Array<string> = []
  DataList_Activity: Array<LetterRequestCustomer_Activity> = []
  Data_Seleted_Delete: any

  Selection_KarshnasMasol_Id: String = "0"
  Selection_KarshnasMasol_Link: String = "0"
  Selection_KarshnasMasol_Link_Dsc: String = ""
  Selection_Dsc: String = ""
  BaseURlFile = environment.BaseUrl

  constructor(
    private Customer_Service: CustomerService,
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Read_Activity()
  }



  //#region Image

  modalRef_Image: any;
  ModalimageUrl: string = ''
  openModal(template: TemplateRef<any>, imageUrl: string) {
    this.ModalimageUrl = imageUrl
    this.modalRef_Image = this.modalService.show(template);
  }

  //#endregion


  Read_Activity() {
    this.InProccessing = true
    this.LetterRequestCustomer_Service.GetActivity(Number(this.inner_Letter_id), this.Token).subscribe(
      data => {


        this.InProccessing = false
        this.DataList_Activity = data
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  modalRef_Delete: any
  openModalRemove(template: TemplateRef<any>, Record) {
    this.Data_Seleted_Delete = Record
    this.modalRef_Delete = this.modalService.show(template);
  }

  Delete() {
    this.InProccessing = true
    this.modalRef_Delete.hide()
    this.LetterRequestCustomer_Service.DeleteActivity(this.Data_Seleted_Delete.id, this.Token).subscribe(
      data => {
        if (data['id'] == '-1') {
          this.Alertify_Service.ErrorMessage("The deletion deadline has passed.")
        }
        else {
          this.Alertify_Service.SuccessMessage("Deleted successfully.")
          this.Read_Activity()
        }
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

}
